import m from "../../geodata/es2015/lithuaniaHigh";
window.am4geodata_lithuaniaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/lithuaniaHigh.js
// module id = null
// module chunks = 